import type { Translations } from '../../types'
import auditLogsMessages from './auditLogs'
import authMessages from './auth'
import builderMessages from './builder'
import commandMessages from './command'
import commonMessages from './common'
import crumbsMessages from './crumbs'
import customersMessages from './customers'
import dashboardMessages from './dashboard'
import featureFlagsMessages from './featureFlags'
import homepageMessages from './homepage'
import mediaMessages from './media'
import menuMessages from './menu'
import navMessages from './nav'
import ordersMessages from './orders'
import pagesMessages from './pages'
import pluginsMessages from './plugins'
import profileMessages from './profile'
import rolesMessages from './roles'
import securityMessages from './security'
import setupMessages from './setup'
import shopMessages from './shop'
import productTypeStudioMessages from './productTypeStudio'
import siteSettingsMessages from './siteSettings'
import sliderMessages from './slider'
import supportMessages from './support'
import systemStatusMessages from './systemStatus'
import themesMessages from './themes'
import titlesMessages from './titles'
import untrustedMessages from './untrusted'
import updatesMessages from './updates'

export const messages: Translations = {
  ...auditLogsMessages,
  ...authMessages,
  ...builderMessages,
  ...commandMessages,
  ...commonMessages,
  ...crumbsMessages,
  ...customersMessages,
  ...dashboardMessages,
  ...featureFlagsMessages,
  ...homepageMessages,
  ...mediaMessages,
  ...menuMessages,
  ...navMessages,
  ...ordersMessages,
  ...pagesMessages,
  ...pluginsMessages,
  ...profileMessages,
  ...rolesMessages,
  ...securityMessages,
  ...setupMessages,
  ...shopMessages,
  ...productTypeStudioMessages,
  ...siteSettingsMessages,
  ...sliderMessages,
  ...supportMessages,
  ...systemStatusMessages,
  ...themesMessages,
  ...titlesMessages,
  ...updatesMessages,
  ...untrustedMessages,
}
